import { render, staticRenderFns } from "./MailTemplateDialog.vue?vue&type=template&id=af5407e6&scoped=true&"
import script from "./MailTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./MailTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5407e6",
  null
  
)

export default component.exports